
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M10.534 33.203c.552.49 1.472.858 2.515 1.226 2.147.675 5.03 1.043 7.853 1.043 1.901 0 3.742-.122 5.46-.43 1.656-.306 3.129-.735 4.172-1.287.674-.369 1.165-.798 1.41-1.227q.185-.369.185-.737V16.147c0-.245-.123-.49-.307-.736-.184-.245-.368-.49-.675-.675-.613-.43-1.472-.859-2.515-1.166-2.086-.613-4.908-.981-7.73-.981-1.84 0-3.681.123-5.338.43-1.656.306-3.067.674-4.172 1.226-.674.369-1.227.737-1.472 1.166-.184.245-.245.49-.307.736v15.644q0 .368.184.737c.246.245.43.49.736.675Z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-miterlimit":"10","d":"M23.97 11.976v-3.56m11.043 6.074h4.846V8.418M12.743 22.466H8.14V8.417m.001 0a2.209 2.209 0 1 0 0-4.417 2.209 2.209 0 0 0 0 4.417Zm15.829 0a2.209 2.209 0 1 0 0-4.417 2.209 2.209 0 0 0 0 4.417Zm15.889 0a2.209 2.209 0 1 0 0-4.417 2.209 2.209 0 0 0 0 4.417ZM23.97 36.025v3.558m-11.043-6.336H8.14v6.336m27.056-13.988h4.663v13.988m0 4.417a2.209 2.209 0 1 0 0-4.417 2.209 2.209 0 0 0 0 4.417ZM23.97 44a2.209 2.209 0 1 0 0-4.417 2.209 2.209 0 0 0 0 4.417ZM8.141 44a2.209 2.209 0 1 0 0-4.417 2.209 2.209 0 0 0 0 4.417Z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"M35.589 15.574c0 1.987-5.175 3.598-11.558 3.598s-11.558-1.61-11.558-3.598m23.116 0c0-1.988-5.175-3.598-11.558-3.598s-11.558 1.61-11.558 3.598m23.116 0V25.1m-23.116-9.527V25.1m0 0v8.197c3.782 1.955 12.32 5.448 23.116 0V25.1m-23.116 0c3.652 1.83 13.388 4.39 23.116 0"}})])
          )
        }
      }
    